module.exports = __webpack_public_path__ + "img/dea-formazione-ico-parita-di-genere.25e41a45.svg";